import { Cache } from 'aws-amplify'
import CdnImage from 'components/util/CdnImage'
// import CloudinaryImage from 'components/util/CloudinaryImage'
import { getCognitoId } from 'components/util/UserId'
import { Field, Formik, useFormikContext } from 'formik'
import FormikErrorFocus from 'formik-error-focus'
import { navigate } from 'gatsby'
import { StaticImage } from 'gatsby-plugin-image'
import { parse } from 'query-string'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Select, { components } from 'react-select'
import { updateCouponCodeValidity } from 'state/actions/dogAction'
import Api from 'state/apis/api'
import Clock from '../../../images/Clock.svg'

import './index.css'
import { growthbookBuilderVariantUtil } from 'components/util/Growthbook'
import { triggerTagging } from 'components/util/common-utils'

enum Alignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

interface Props {
  backgroundColor: string
  isImageFirst: boolean
  backgroundImage: any
  builderBackgroundImage: any
  backgroundImageAlt: string
  titleTextOne: string
  titleTextTwo: string
  tagLine: string
  textAlignment: Alignment
  buttonEnabled: boolean
  buttonProp: LinkButtonProp
  widgetBackgroundColor: string
  widgetType: WidgetType
  widgetTags: string
  widgetColor: string
  widgetPlaceholder: boolean
  heroFooterBackground: string
  coupon: string
  defaultOffer: boolean
  couponText: string
  growthbookFeatureId: string
  enabled: boolean
  removeFormSection: boolean
  removeWidget: boolean
  showExtraMessage: boolean
  showTrustpilotImage: boolean
}

const HeroDogCTAVersionTwo = ({
  backgroundColor,
  isImageFirst,
  backgroundImage,
  builderBackgroundImage,
  backgroundImageAlt,
  titleTextOne,
  titleTextTwo,
  tagLine,
  textAlignment,
  buttonEnabled,
  buttonProp,
  widgetBackgroundColor,
  widgetType,
  widgetTags,
  widgetColor,
  widgetPlaceholder,
  heroFooterBackground,
  coupon = '',
  defaultOffer,
  couponText,
  growthbookFeatureId = '',
  enabled = false,
  removeFormSection = false,
  removeWidget = false,
  showExtraMessage = false,
  formType = '',
  showTrustpilotImage = false
}: Props) => {
  const formikRef = React.useRef<any>()
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [couponMessage, setCouponMessage] = useState('')
  const [breeds, setBreeds] = useState([])
  const [sortedBreeds, setSortedBreeds] = useState([])
  const [gbVariant, setGBVariant] = useState<number>(1)
  const dogDetailsPage = 'dog-details'

  const {
    isValidCoupon,
    lastValidatedCoupons
  }: {
    isValidCoupon: boolean
    lastValidatedCoupons: CouponsType[]
    loading: boolean
  } = useSelector((state: RootState) => state.dog)
  const dispatch = useDispatch()

  useEffect(() => {
    const weights = [33, 33, 34]
    const getGBVariant = growthbookBuilderVariantUtil(growthbookFeatureId, weights, enabled, 1)
    setGBVariant(getGBVariant)
  }, [])

  useEffect(() => {
    if (formType === 'breed') {
      setGBVariant(3)
    }
    if (formType === 'name') {
      setGBVariant(2)
    }
    if (formType === 'cta') {
      setGBVariant(1)
    }
  }, [formType])

  useEffect(() => {
    const authenticateUser = async () => {
      try {
        const { username } = await getCognitoId()

        if (username) {
          setIsLoggedIn(true)
        }
      } catch (e) {
        console.log(e)
      }
    }

    authenticateUser()
  }, [isLoggedIn])

  useEffect(() => {
    const trustWidget = document.getElementById('trust-pilot-micro-combo')
    window.Trustpilot?.loadFromElement(trustWidget)
  }, [widgetType])

  const getAlignmentClass = () => {
    if (textAlignment === Alignment.Right) {
      return 'text-right'
    }
    if (textAlignment === Alignment.Center) {
      return 'text-center'
    }
    return 'text-left'
  }

  // Handle coupons from the URL querystring
  useEffect(() => {
    // Priorise the QS sign up flow coupon, then look for a content page coupon, otherwise we fallback to the default
    if (!defaultOffer) {
      const { coupon: couponFromQueryStr } = parse(location.search)
      let coupon = couponFromQueryStr ?? Cache.getItem('coupon') ?? null
      if (coupon) {
        coupon = coupon.toUpperCase()
        dispatch(updateCouponCodeValidity('checkValidity', coupon as string))

        if (isValidCoupon) {
          const couponMessageText = getCouponMessage()
          setCouponMessage(couponMessageText)
        }
      }
    }
  }, [])

  useEffect(() => {
    if (lastValidatedCoupons?.length) setCouponMessage(getCouponMessage())
  }, [lastValidatedCoupons])

  useEffect(() => {
    callBreeds()
  }, [])

  const listBreeds = (sort = '') => {
    if (!sort) {
      setSortedBreeds(breeds)
      return
    }
    // Sort the breeds to put the user typed breeds at the top
    setSortedBreeds(
      [...breeds].sort((a, b) => {
        if (a.label.toLowerCase().startsWith(sort.toLowerCase())) {
          return -1
        } else if (b.label.toLowerCase().startsWith(sort.toLowerCase())) {
          return 1
        } else {
          return a.label.localeCompare(b.label)
        }
      })
    )
  }

  const callBreeds = () => {
    const url = '/v1/public/signup/breeds'
    Api.get('wwwREST', url, {})
      .then(({ breedsList }) => {
        setBreeds(breedsList)
        setSortedBreeds(breedsList)
      })
      .catch(err => {
        console.log(err)
      })
  }

  // Create dynamic coupon message
  const getCouponMessage = () => {
    return `${
      lastValidatedCoupons[0]?.type === 'percentage'
        ? lastValidatedCoupons[0].amount + '%'
        : '£' + (lastValidatedCoupons[0].amount / 100).toFixed(2)
    } off ${lastValidatedCoupons[0].uses > 1 ? `your first ${lastValidatedCoupons[0].uses} orders!` : 'your first order + Free Treat'}`
  }

  const renderMobileTextImage = () => {
    return (
      <div>
        <div className={`${getAlignmentClass()} w-4/5 mx-auto pt-12`}>
          <span className="text-[#004355] text-4xl font-medium font-serif">{titleTextOne}</span>
          <br />
          <div className="mt-3" />
          <span className="text-[#006685] text-4xl font-medium font-serif"> {titleTextTwo}</span>
        </div>
        <p
          className={`enable-list-styles text-base font-semibold font-sans ${getAlignmentClass()} w-4/5 mx-auto mt-4 mb-2 text-[#004355]`}
          dangerouslySetInnerHTML={{ __html: tagLine }}
        ></p>{' '}
      </div>
    )
  }

  const renderCTAButton = () => {
    if (!buttonEnabled) {
      return (
        <button
          className={`mx-auto flex w-10/12 items-center justify-center rounded-full border border-transparent bg-primary px-5 py-3 text-base font-medium text-[#FFFFFF] md:mt-8 md:w-96 md:text-lg`}
          onClick={() => {
            let eventName = isLoggedIn
              ? 'cta_component_dog_hero_cta_submit_logged_in'
              : 'cta_component_dog_hero_cta_submit'
            const turboRoute = document?.querySelector('#turboRoute')
            if (turboRoute) {
              triggerTagging('hero_dog_cta_turbo_route', 'turbo_route')
              turboRoute.scrollIntoView({ behavior: 'smooth', block: 'start' })
            } else {
              if (typeof window.gtag !== 'undefined') {
                window.gtag('event', eventName, {
                  page: 'home_page'
                })
                //TODO:DS Duplication to test category/label (remove above if working)
                window.gtag('event', eventName, {
                  page: 'home_page',
                  event_category: eventName,
                  event_label: eventName
                })
              }
              if (isLoggedIn) {
                navigate('/account/')
              } else {
                window.location.href = `/signup/${dogDetailsPage}/${coupon ? `?coupon=${coupon}` : ''}`
              }
            }
          }}
        >
          {isLoggedIn ? `${buttonProp?.loggedInButtonText}` : `${buttonProp?.buttonText}`}
        </button>
      )
    }

    return null
  }

  const renderABTest = () => {
    if (gbVariant) {
      return <>{renderInputSection()}</>
    } else {
      // Skeleton section
      return (
        <div className={`mx-auto mt-4 w-full rounded-3xl  p-4 h-40 flex flex-col justify-end items-center`}>
          <div className="mt-3 flex w-full items-center justify-center">
            <button
              type="button"
              className="mx-1 mb-4 flex w-full justify-center rounded-3xl border border-transparent bg-primary px-4 py-2 text-base font-medium hover:underline md:w-[90%] md:text-lg"
              onClick={() => {
                let eventName = isLoggedIn
                  ? 'cta_component_dog_hero_cta_submit_logged_in'
                  : 'cta_component_dog_hero_cta_submit'

                if (typeof window.gtag !== 'undefined') {
                  window.gtag('event', eventName, {
                    page: 'home_page'
                  })
                }
                if (isLoggedIn) {
                  navigate('/account/')
                } else {
                  window.location.href = `/signup/${dogDetailsPage}/${coupon ? `?coupon=${coupon}` : ''}`
                }
              }}
              style={{ color: '#fff' }}
            >
              {isLoggedIn ? `${buttonProp?.loggedInButtonText}` : `${buttonProp?.buttonText}`}
            </button>
          </div>
          <div className="pb-1 text-center text-xs">
            <div className="flex flex-row justify-center">
              <img className="mr-1" width={14} src={Clock} alt="Clock" />
              <span>
                It takes about <span className="font-bold">2 mins</span>
              </span>
            </div>
          </div>
        </div>
      )
    }
  }

  const DropdownIndicator = (props: ElementConfig<typeof components.DropdownIndicator>) => {
    return (
      <components.DropdownIndicator {...props}>
        <StaticImage className="w-5 h-full" src="../../../images/checkout/cheveronDown.svg" alt="Dropdown" />
      </components.DropdownIndicator>
    )
  }

  const renderInputSection = () => {
    if (gbVariant !== 1)
      return (
        <Formik
          innerRef={formikRef}
          initialValues={{
            name: '',
            breed: ''
          }}
          onSubmit={async values => {
            let eventName = isLoggedIn
              ? 'dog_name_component_dog_hero_submit_logged_in'
              : 'dog_name_component_dog_hero_submit'

            if (!values.name && !values.breed) {
              let url = `/signup/${dogDetailsPage}/`
              if (coupon) url += `?coupon=${coupon}`
              // window.location.href = url
              if (typeof window.gtag !== 'undefined') {
                window.gtag('event', eventName, {
                  page: 'home_page'
                })
              }
            } else if (values.name) {
              if (typeof window.gtag !== 'undefined') {
                window.gtag('event', eventName, {
                  page: 'home_page',
                  dog_name: values.name
                })
              }
              let url = `/signup/${dogDetailsPage}/?d=${encodeURI(btoa(values.name))}`
              if (coupon) url += `&coupon=${coupon}`
              window.location.href = url
            } else if (values.breed) {
              if (typeof window.gtag !== 'undefined') {
                window.gtag('event', eventName, {
                  page: 'home_page',
                  dog_breed: values.breed
                })
              }
              let url = `/signup/${dogDetailsPage}/?b=${encodeURI(btoa(values.breed))}`
              if (coupon) url += `&coupon=${coupon}`
              window.location.href = url
            }
          }}
          validateOnMount={false}
        >
          {props => {
            return (
              <>
                <FormikErrorFocus
                  formik={useFormikContext()}
                  offset={0}
                  align={'middle'}
                  focusDelay={1000}
                  ease={'linear'}
                  duration={1000}
                />
                {gbVariant === 2 && (
                  <div className={`mx-auto w-full rounded-3xl bg-white p-4`}>
                    <span className="text-sm font-medium mb-4 flex justify-center whitespace-nowrap text-center font-sans">
                      Who are we cooking for today?
                    </span>
                    <div className="my-4 flex w-full items-center justify-center">
                      <Field
                        type="text"
                        name="name"
                        label="name"
                        placeholder="Your dog's name"
                        className={
                          'peer mx-1 block w-[97%] rounded-3xl border border-gray-300 bg-white text-center focus:border-[#B0CDD5] focus:ring-0'
                        }
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                          props.setFieldValue('name', e.target.value)
                        }}
                        onKeyDown={e => {
                          if (e.key === 'Enter') {
                            props.handleSubmit()
                          }
                        }}
                      />
                      {props.errors.name && props.touched.name ? (
                        <div className="text-xs text-red-500">{props.errors.name}</div>
                      ) : null}
                    </div>
                    <div className="mt-3 flex w-full items-center justify-center">
                      <button
                        type="button"
                        className="mx-1 mb-4 flex w-full justify-center rounded-3xl border border-transparent bg-primary px-4 py-2 text-base font-medium hover:underline md:w-[90%] md:text-lg"
                        onClick={() => props.handleSubmit()}
                        style={{ color: '#fff' }}
                      >
                        Create Your Plan
                      </button>
                    </div>
                    <div className="pb-1 text-center text-xs">
                      <div className="flex flex-row justify-center">
                        <img className="mr-1" width={14} src={Clock} alt="Clock" />
                        <span>
                          It takes about <span className="font-bold">2 mins</span>
                        </span>
                      </div>
                    </div>
                  </div>
                )}
                {gbVariant === 3 && (
                  <div className={`mx-auto w-full rounded-3xl bg-white p-3`}>
                    <span className="text-sm font-medium mb-4 flex justify-center whitespace-nowrap text-center font-sans ">
                      What breed is your dog?
                    </span>
                    <div className="my-4 flex w-full items-center justify-center">
                      <Select
                        className="block w-[97%] lg:w-11/12 self-center rounded-full border-2 border-secondary bg-white py-2 px-4 text-center focus:border-highlight focus:ring-highlight mx-auto z-50"
                        theme={theme => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            primary25: '#F5F1ED',
                            primary: '#6BA2B3',
                            primary50: '#6BA2B3'
                          }
                        })}
                        styles={{
                          control: (base, _state) => ({
                            ...base,
                            zIndex: 9999,
                            border: 'none',
                            boxShadow: 'none !important',
                            '*': {
                              boxShadow: 'none !important'
                            },
                            '&:hover': {
                              border: 'none !important'
                            },
                            fontSize: '12px'
                          }),
                          valueContainer: (provided, _state) => ({
                            ...provided,
                            padding: '0',
                            borderRadius: '30px'
                          }),
                          menu: provided => ({
                            ...provided,
                            borderRadius: '10px',
                            margin: '0 auto',
                            width: '92%',
                            justifyContent: 'center'
                          }),
                          dropdownIndicator: base => ({
                            ...base,
                            color: '#006685'
                          })
                        }}
                        components={{
                          IndicatorSeparator: () => null,
                          DropdownIndicator
                        }}
                        placeholder={'Tap to select or start typing'}
                        onChange={(e: any) => {
                          props.setFieldValue('breed', e.value.toString())
                          listBreeds()
                        }}
                        onInputChange={(e: any) => {
                          listBreeds(e)
                        }}
                        options={sortedBreeds}
                        isClearable={false}
                        onBlur={(e: any) => {
                          if (e.value) {
                            props.setFieldValue('breed', e.value.toString())
                            listBreeds()
                          }
                        }}
                      />
                      {props.errors.breed && props.touched.breed ? (
                        <div className="text-xs text-red-500">{props.errors.breed}</div>
                      ) : null}
                    </div>
                    <div className="mt-3 flex w-full items-center justify-center">
                      <button
                        type="button"
                        className="mx-1 mb-4 flex w-full justify-center rounded-3xl border border-transparent bg-primary px-4 py-2 text-base font-medium hover:underline md:w-[90%] md:text-lg"
                        onClick={() => props.handleSubmit()}
                        style={{ color: '#fff' }}
                      >
                        Create Your Plan
                      </button>
                    </div>
                    <div className="pb-3 text-center text-xs">
                      <div className="flex flex-row justify-center">
                        <span>Our food is great for dogs of all shapes and sizes</span>
                      </div>
                    </div>
                    <div className="pb-1 text-center text-xs">
                      <div className="flex flex-row justify-center">
                        <img className="mr-1" width={14} src={Clock} alt="Clock" />
                        <span>
                          It takes about <span className="font-bold">2 mins</span>
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )
          }}
        </Formik>
      )

    if (gbVariant === 1) {
      return <div className="my-2 mx-auto w-4/5">{renderCTAButton()}</div>
    }
  }

  const getWidget = () => {
    return (
      <div>
        {/* <!-- TrustBox widget - Micro Combo --> */}
        <div
          className="trustpilot-widget px-8 py-4"
          data-locale="en-GB"
          data-template-id="5419b6ffb0d04a076446a9af"
          data-businessunit-id="5af423d4a3303b0001bf47c1"
          data-style-height="20px"
          data-style-width="100%"
          data-theme="light"
          data-stars="5"
          data-font-family="Montserrat"
          data-text-color={widgetColor ? widgetColor : ''}
          data-tags={widgetTags ? widgetTags : ''}
          id="trust-pilot-micro-combo"
        >
          <a href="https://uk.trustpilot.com/review/differentdog.com" target="_blank" rel="noreferrer noopener">
            <StaticImage
              objectFit="contain"
              className="w-full -mt-2"
              src="../../../images/trustpilot-single-line.png"
              alt="Trustpilot"
            />
          </a>
        </div>
        {/* <!-- End TrustBox widget --> */}
      </div>
    )
  }

  return (
    <>
      <div className="bg-image-none relative -mb-4 h-full w-full bg-contain md:bg-cover md:bg-no-repeat">
        <CdnImage
          className={`absolute left-0 top-0 h-full ${!removeFormSection && !removeWidget ? 'min-h-[38rem]' : 'min-h-[34rem]'} w-full max-w-full object-cover object-bottom z-10 -mt-4 aspect-auto bg-transparent text-white`}
          url={builderBackgroundImage}
          alt={backgroundImageAlt}
          // lazyLoad={true}
          style={{
            dpr: 'auto'
          }}
        />

        {/* {builderBackgroundImage ? (
          // <CdnImage
          //   className="absolute left-0 top-0 h-full min-h-[38rem] w-full max-w-full object-cover object-bottom z-10 -mt-4 aspect-auto bg-transparent text-white"
          //   url={builderBackgroundImage}
          //   alt={backgroundImageAlt}
          //   lazyLoad={true}
          //   style={{
          //     dpr: 'auto'
          //   }}
          // />
        ) : (
          <CloudinaryImage
            className="absolute top-0 left-0 h-full min-h-[38rem] w-full max-w-full object-cover object-bottom z-10 -mt-4 aspect-auto bg-transparent text-white"
            publicId={backgroundImage?.public_id}
            alt={backgroundImageAlt}
            loading={'eager'}
            style={{
              dpr: 'auto'
            }}
            quality={'auto'}
          />
        )} */}
        <main
          className={`mx-auto relative flex h-full w-full ${isImageFirst ? 'pt-[18rem]' : ''} flex-col z-50 pb-4 xs:pb-44 sm:pb-56 md:pb-[24rem]`}
        >
          <div className="-mt-6 block h-full min-h-[11rem]">{renderMobileTextImage()}</div>
          {!removeFormSection && (
            <>
              {!enabled && (
                <>
                  {' '}
                  <div className="my-2 mx-auto w-4/5">{renderCTAButton()}</div>
                  <div className="mt-1 text-center text-xs">
                    <div className="flex flex-row justify-center pb-3">
                      <img className="mr-1" width={14} src={Clock} alt="Clock" />
                      <span>
                        It takes about <span className="font-bold">2 mins</span>
                      </span>
                    </div>
                  </div>
                </>
              )}
              {showExtraMessage && (
                <>
                  {' '}
                  <div className="my-2 mx-auto w-4/5">{renderCTAButton()}</div>
                  <div className="mt-1 text-center text-sm">
                    <div className="flex flex-row justify-center pb-3">
                      <span>Empty bowl guarantee</span>
                    </div>
                  </div>
                </>
              )}
              {enabled && !showExtraMessage && (
                <div
                  className={`mx-auto ${gbVariant !== 1 ? 'my-0' : 'my-2'} ${gbVariant === 3 ? 'w-[90%]' : 'w-4/5'}`}
                >
                  {' '}
                  {renderABTest()}
                </div>
              )}
            </>
          )}
          {!removeWidget && <div className="w-full">{getWidget()}</div>}
          {removeWidget && showTrustpilotImage && (
            <div className="w-2/3 py-2 lg:-mt-2 mb-2 justify-center mx-auto">
              {' '}
              <a href="https://uk.trustpilot.com/review/differentdog.com" target="_blank" rel="noreferrer noopener">
                <StaticImage
                  objectFit="contain"
                  className="w-full"
                  src="../../../images/trustpilot-shortened.svg"
                  alt="Trustpilot"
                />
              </a>
            </div>
          )}
          <div className={`${isImageFirst ? 'mt-8' : 'mt-2'} block w-full`} />
        </main>
        {!isImageFirst && <div className={'bg-[#FAECE8] pt-[18rem]'}></div>}
        <div
          className={`${
            heroFooterBackground ? 'block' : 'hidden'
          } font-sans-serif absolute bottom-0 z-20 h-12 w-full bg-cover bg-bottom bg-no-repeat pb-4 text-center text-base`}
          style={{
            backgroundImage: heroFooterBackground ? `url(${heroFooterBackground})` : 'none',
            marginBottom: '0rem'
          }}
        ></div>
      </div>
    </>
  )
}

export default HeroDogCTAVersionTwo
